import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function Footer() {
  const theme = useTheme();

  return (
    // <Box
    //   component="footer"
    //   sx={{
    //     position: 'fixed',
    //     bottom: 0,
    //     left: 0,
    //     right: 0,
    //     backgroundColor: theme.palette.background.paper,
    //     borderTop: `1px solid ${theme.palette.divider}`,
    //     zIndex: theme.zIndex.drawer + 1,
    //     height: 30,
    //     display: 'flex',
    //     alignItems: 'center'
    //   }}
    // >
    //   <Container maxWidth="lg">
    //     <Box
    //       sx={{
    //         display: 'flex',
    //         justifyContent: 'space-between',
    //         alignItems: 'center'
    //       }}
    //     >
    //       <Typography variant="body2" color="text.secondary">
    //         © {new Date().getFullYear()} Teleposter. All rights reserved.
    //       </Typography>
    //       <Typography variant="body2" color="text.secondary">
    //         v{process.env.REACT_APP_VERSION}
    //       </Typography>
    //     </Box>
    //   </Container>
    // </Box>

    <div></div>
  );
}

export default Footer;